import React from 'react'
import App from './app/App'
import { Provider } from 'react-redux'
import { sharedStore, UserHelper } from '@Techedge/digitalportal-shared'

export default function Root(props: any) {
    return (
        <Provider store={sharedStore}>
            <App {...props} />
        </Provider>
    )
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals()
